import { useEffect, useRef } from 'react';
import { useOnIntersection } from '../../hooks';
import { getIntersectionData } from '../../utils';
export var useModernStickyProps = function useModernStickyProps(props) {
  var onBottomStuck = props.onBottomStuck,
    onTopStuck = props.onTopStuck,
    root = props.root;
  var intersectionObserverRef = useRef(null);
  var sentinelRef = useRef(null);
  var _useOnIntersection = useOnIntersection({
      onBottomStuck: onBottomStuck,
      onTopStuck: onTopStuck
    }),
    onIntersection = _useOnIntersection.onIntersection,
    isOnBottomStuck = _useOnIntersection.isOnBottomStuck,
    isOnTopStuck = _useOnIntersection.isOnTopStuck;
  useEffect(function () {
    if (!sentinelRef.current) {
      return;
    }
    intersectionObserverRef.current = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      onIntersection(getIntersectionData(entry.boundingClientRect, root));
    },
    /* NOTE: отрицательный margin, чтобы срабатывало событие пересечения до фактического пересечения
    (которое в случае 0 не происходит, т.к. элемент полностью находится в пределах видимости,
    а стики элемент *всегда* полностью находится в пределах видимости).
    Значение -0.01px взято по причине желания свести к минимуму отличие зоны пересечения от фактической зоны видимости.
    Однако в intersactionRect значение округляется автоматически до 1
    (см разницу в высоте boundingClientRect.height === intersectionRect.height - 1px)
     */
    {
      threshold: [0, 1],
      rootMargin: '-0.01px 0px',
      root: root
    });
    intersectionObserverRef.current.observe(sentinelRef.current);
    return function () {
      var _intersectionObserver;
      /* istanbul ignore next */
      (_intersectionObserver = intersectionObserverRef.current) === null || _intersectionObserver === void 0 ? void 0 : _intersectionObserver.disconnect();
    };
  }, [onIntersection, root]);
  return {
    sentinelRef: sentinelRef,
    isOnBottomStuck: isOnBottomStuck,
    isOnTopStuck: isOnTopStuck
  };
};